import { render } from "./BermudaPage.vue?vue&type=template&id=5921d2a6&scoped=true"
import script from "./BermudaPage.vue?vue&type=script&lang=js"
export * from "./BermudaPage.vue?vue&type=script&lang=js"

import "./BermudaPage.vue?vue&type=style&index=0&id=5921d2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5921d2a6"]])

export default __exports__